import { computed } from "vue";
import { useIDBKeyval } from "@vueuse/integrations/useIDBKeyval";

export enum PhaseId {
  PRODUCTION = "Production",
  DEPLOYMENT = "Deployment",
  STORAGE = "Storage",
  SHIPPING = "Shipping",
  INSTALLATION = "Installation",
  IMPLANTATION = "Implantation",
  TRANSPORT = "Transport",
  PREPARATION = "Preparation",
  USE = "Use",
  EXPLANATION = "Explanation",
  MAINTENANCE = "Maintenance",
  UPDATE = "Update",
  REFURBISHING = "Refurbishing",
  DISPOSAL = "Disposal",
}

export interface Phase {
  id: PhaseId;
  name: string;
  description: string;
  isEnabled: boolean;
  icon: string;
}

const phaseDefinitions: Omit<Phase, "isEnabled">[] = [
  {
    id: PhaseId.PRODUCTION,
    name: "Production",
    description: "",
    icon: "factory",
  },
  {
    id: PhaseId.DEPLOYMENT,
    name: "Deployment",
    description: "",
    icon: "install_desktop",
  },
  {
    id: PhaseId.STORAGE,
    name: "Storage",
    description: "",
    icon: "shelves",
  },
  {
    id: PhaseId.SHIPPING,
    name: "Shipping",
    description: "",
    icon: "local_shipping",
  },
  {
    id: PhaseId.INSTALLATION,
    name: "Installation",
    description: "",
    icon: "build",
  },
  {
    id: PhaseId.IMPLANTATION,
    name: "Implantation",
    description: "",
    icon: "build",
  },
  {
    id: PhaseId.TRANSPORT,
    name: "Transport",
    description: "",
    icon: "local_shipping",
  },
  {
    id: PhaseId.PREPARATION,
    name: "Preparation",
    description: "",
    icon: "chef_hat",
  },
  {
    id: PhaseId.USE,
    name: "Use",
    description: "",
    icon: "stethoscope",
  },
  {
    id: PhaseId.EXPLANATION,
    name: "Explanation",
    description: "",
    icon: "stethoscope",
  },
  {
    id: PhaseId.MAINTENANCE,
    name: "Maintenance",
    description: "",
    icon: "home_repair_service",
  },
  {
    id: PhaseId.UPDATE,
    name: "Update",
    description: "",
    icon: "cached",
  },
  {
    id: PhaseId.REFURBISHING,
    name: "Refurbishing",
    description: "",
    icon: "star_shine",
  },
  {
    id: PhaseId.DISPOSAL,
    name: "Disposal",
    description: "",
    icon: "delete",
  },
];

const { data: enabledPhases } = useIDBKeyval<PhaseId[]>(
  "enabledPhases",
  [PhaseId.USE],
  { shallow: false }
);

const phases = computed<Phase[]>(() => {
  const set = new Set(enabledPhases.value);
  return phaseDefinitions.map((p) => ({
    ...p,
    isEnabled: set.has(p.id),
  }));
});

function setPhaseEnabled(id: PhaseId, enabled: boolean) {
  const current = new Set(enabledPhases.value);
  if (enabled) current.add(id);
  else current.delete(id);
  enabledPhases.value = Array.from(current);
}

export function lifecyclePhasesState() {
  return { phases, setPhaseEnabled };
}
